import script from "./FilterDistributionGroupCustomer.vue?vue&type=script&lang=ts&setup=true"
export * from "./FilterDistributionGroupCustomer.vue?vue&type=script&lang=ts&setup=true"

import "./FilterDistributionGroupCustomer.vue?vue&type=style&index=0&id=10bddd50&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10bddd50"]])

export default __exports__